import { getEnv } from '@next-box/envs/server';
import { enGB, es, fr } from 'date-fns/locale';
import { content as enContent } from './en/index.ts';
import { content as esContent } from './es/index.ts';
import { content as frContent } from './fr/index.ts';

const dateLocales = {
  en: enGB,
  es,
  fr,
};

const languages = {
  en: enContent,
  es: esContent,
  fr: frContent,
};

const languageCode = getEnv<'en' | 'es' | 'fr'>('NEXT_PUBLIC_LANGUAGE_CODE');
export const dateLocale = dateLocales[languageCode];
export const content = languages[languageCode];
